import PlanAndPricingContainer from "./PlanAndPricingContainer";
import PlanAndPricingStore from "./PlanAndPricingStore";

export default PlanAndPricingStore(PlanAndPricingContainer);
